import type { RespondentFilterUsingMetaResultsQuery$data } from './__generated__/RespondentFilterUsingMetaResultsQuery.graphql';

export const getResponseCountFromMetaResults = (
    metaKey: string,
    metaValue: string,
    metaResults: RespondentFilterUsingMetaResultsQuery$data['metaResults'],
): number =>
    metaResults
        .filter((f) => metaKey === f.metaKey && metaValue === f.metaValue)
        .map(({ responseCount }) => responseCount)
        .pop() || 0;
